var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIxReplace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00025 4C8.00025 4.82842 7.32867 5.5 6.50025 5.5C5.67183 5.5 5.00025 4.82842 5.00025 4C5.00025 3.17158 5.67183 2.5 6.50025 2.5C7.32867 2.5 8.00025 3.17158 8.00025 4ZM6.50016 7.5858L10.9144 12L9.50016 13.4142L7.49995 11.414L7.50014 16C7.50014 17.6569 8.8433 19 10.5001 19H14.5002V21H10.5001C7.73873 21 5.50017 18.7615 5.50017 16L5.49994 11.414L3.50016 13.4142L2.08594 12L6.50016 7.5858ZM14.5002 3.00002C17.2616 3.00002 19.5001 5.23858 19.5001 8.00003L19.5 12.584L21.5002 10.5858L22.9144 12L18.5002 16.4142L14.0859 12L15.5002 10.5858C16.1664 11.2522 16.833 11.9183 17.4999 12.584L17.5002 8.00003C17.5002 6.34314 16.157 5.00003 14.5002 5.00003H10.5001V3.00002H14.5002ZM18.5002 21.5C19.3287 21.5 20.0002 20.8285 20.0002 20C20.0002 19.1716 19.3287 18.5 18.5002 18.5C17.6718 18.5 17.0002 19.1716 17.0002 20C17.0002 20.8285 17.6718 21.5 18.5002 21.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIxReplace);
export default __webpack_public_path__ + "static/media/ix_replace.488fc39a9df72e8a424b729afae236ab.svg";
export { ForwardRef as ReactComponent };